import { commonTranslationEN } from "@common/translations/en";

export const spreadsheetDetailsEN = {
  ...commonTranslationEN,
  'Edit': 'Edit',
  'Load Fmt': 'Load Fmt',
  'Save Fmt': 'Save Fmt',
  'Export': 'Export',
  'Import': 'Import',
  'Batch Letters': 'Batch Letters',
  'Batch Invites': 'Batch Invites',
  'Count': 'Count',
  'Undo': 'Undo',
  'Redo': 'Redo',
  'Import more': 'Import more',
  'numberOfMatchedColumns': 'Number of unique identifiers in the import file that match columns in the spreadsheet',
  'Data Options': 'Data Options',
  'Import blank cells over existing data': 'Import blank cells over existing data',
  'Import blank cells': 'Import blank cells',
  'Import into tables only': 'Import into tables only',
  'Tab Delimited': 'Tab Delimited',
  'Comma Delimited': 'Comma Delimited',
  'Other (specify delimiter)': 'Other (specify delimiter)',
  'Data Import Definition': 'Data Import Definition',
  'Import Data': 'Import Data',
  'Import Warnings': 'Import Warnings',
  'Importing individual data': 'Importing individual data',
  'Importing pedigree data': 'Importing pedigree data',
  'Rows imported': 'Rows imported',
  'out of': 'out of',
  'imported successfully': 'imported successfully',
  'Failed to import data': 'Failed to import data',
  'Load Pedigree Spreadsheet Format': 'Load Pedigree Spreadsheet Format',
  'Load Individual Spreadsheet Format': 'Load Individual Spreadsheet Format',
  'Individual Data Folders': 'Individual Data Folders',
  'Failed to get folders': 'Failed to get folders',
  'Failed to get fields': 'Failed to get fields',
  'No': 'No',
  'Yes': 'Yes',
  'Are you sure you wish to remove all query clauses?': 'Are you sure you wish to remove all query clauses?',
  'Drag Fields From Warehouse And Drop Here': 'Drag Fields From Warehouse And Drop Here',
  'No data': 'No data',
  'No folders': 'No folders',
  'Columns': 'Columns',
  'Move Fields From Columns Panel Above': 'Move Fields From Columns Panel Above',
  'The folder {folderName} already exists. Please enter a different name': 'The folder {folderName} already exists. Please enter a different name',
  'Please select fields to run the spreadsheet': 'Please select fields to run the spreadsheet',
  'Or': 'Or',
  'Save Pedigree Spreadsheet Format': 'Save Pedigree Spreadsheet Format',
  'Save Individual Spreadsheet Format': 'Save Individual Spreadsheet Format',
  'Text (Tab Delimited)': 'Text (Tab Delimited)',
  'Text (Comma Delimited)': 'Text (Comma Delimited)',
  'Text (Other)': 'Text (Other)',
  'Excel (xls)': 'Excel (xls)',
  'Excel (xlsx)': 'Excel (xlsx)',
  'Include Column Headings': 'Include Column Headings',
  'Export Table Rows Only': 'Export Table Rows Only',
  'Export One Row Per Individual': 'Export One Row Per Individual',
  'Retain newlines in formatted cells': 'Retain newlines in formatted cells',
  'Convert newlines to spaces': 'Convert newlines to spaces',
  'Export newlines without any formatting': 'Export newlines without any formatting',
  'Export Data': 'Export Data',
  'Settings': 'Settings',
  'Delimiter': 'Delimiter',
  'Options': 'Options',
  'Newline Handling for Text Fields': 'Newline Handling for Text Fields',
  'Exporting': 'Exporting',
  'Failed to export': 'Failed to export',
  'Failed to get individual folders': 'Failed to get individual folders',
  'Failed to get pedigree folders': 'Failed to get pedigree folders',
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
  'The Questionnaire invitation emails were successfully submitted for all individuals with a valid email address': 'The Questionnaire invitation emails were successfully submitted for all individuals with a valid email address.',
  'No folder selected. Please select a folder first.': 'No folder selected. Please select a folder first.',
  'No individuals found in the current spreadsheet view': 'No individuals found in the current spreadsheet view',
  'Failed to load individuals from spreadsheet': 'Failed to load individuals from spreadsheet',
  'Invitations sent to {emailsSent} individuals. Failed to send to {failedCount} individuals due to invalid email addresses: {failedNames}': 'Invitations sent to {emailsSent} individuals. Failed to send to {failedCount} individuals due to invalid email addresses: {failedNames}',
  'There was a problem with the email addresses for the following individuals': 'There was a problem with the email addresses for the following individuals:',
  'Failed to send invitations': 'Failed to send invitations',
  'The spreadsheet could not be run because a comparison operator is missing a value for the following field(s) in the query. Please fix this error and re-run the spreadsheet': 'The spreadsheet could not be run because a comparison operator is missing a value for the following field(s) in the query. Please fix this error and re-run the spreadsheet',
  'spreadsheet.validation.missing.value': 'The spreadsheet could not be run because a comparison operator is missing a value for the following field(s) in the query. Please fix this error and re-run the spreadsheet',
  'Failed to update cell value': 'Failed to update cell value',
  'Failed to add row': 'Failed to add row',
  'Failed to delete rows': 'Failed to delete rows',
  'Invalid format selected': 'Invalid format selected',
  'Failed to load format data': 'Failed to load format data',
  'Invalid format structure - no columns found': 'Invalid format structure - no columns found',
  'Failed to load format': 'Failed to load format',
  'Failed to save formats': 'Failed to save formats',
  'This name has already been used, would you like to overwrite the current format being used by this name?': 'This name has already been used, would you like to overwrite the current format being used by this name?',
  'Failed to run spreadsheet': 'Failed to run spreadsheet',
  'Format loaded successfully': 'Format loaded successfully',
  'Failed to load stored format data': 'Failed to load stored format data',
  'Pedigree Data Folders': 'Pedigree Data Folders',
  'This field is required': 'This field is required',
  'Missing required data for upload. Please ensure all required fields are available.': 'Missing required data for upload. Please ensure all required fields are available.',
  'Spreadsheet Count': 'Spreadsheet Count',
  'There are {displayCount} main row(s) in this spreadsheet': 'There are %{displayCount} main row(s) in this spreadsheet',
  'Information Message': 'Information Message',
  'Number field accepts numeric values only, please re-try.': 'Number field accepts numeric values only, please re-try.',
  'Invalid number': 'Invalid number',
  'Upload Error': 'Upload Error',
  'Confirmation message': 'Confirmation message',
  'Upload Success': 'Upload Success',
  'Overwrite failed': 'Overwrite failed',
  'Overwrite': 'Overwrite',
  'File upload failed. Please try again.': 'File upload failed. Please try again.',
  'File type not allowed: {fileName}': 'File type not allowed: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'File "{fileName}" already exists. Overwrite?',
  'File "{fileName}" uploaded successfully.': 'File "{fileName}" uploaded successfully.',
  'Browse to {value}': 'Browse to {value}',
  'Open': 'Open',
  'Download': 'Download',
  'Click to view full image for {value}': 'Click to view full image for {value}',
  'Upload Image': 'Upload Image',
  'Upload Document': 'Upload Document',
  'Yes (Y)': 'Yes (Y)',
  'No (N)': 'No (N)',
};